<template>
  <div v-loading="!isOssComplete" class="apply_w site_content">
    <SiteBreadcrumb />

    <div class="content_w site_content bc_fff">
      <div class="step_c_w" v-if="currentStep === 1">
        {{ applyAgreementData.title }}
      </div>
      <div class="risk_tip_w" v-if="currentStep === 1">
        <div class="tip_title font_w_bold fz18">
          <img
            src="@/assets/images/applyTalk.png"
            style="width: 18px; margin-right: 6px; position: relative; top: 2px"
            alt=""
          />报名说明：
        </div>
        <div
          class="desc_w c_1A1A1A fz15"
          v-html="applyAgreementData.applyerTips"
        ></div>
      </div>
      <div class="form_c_w">
        <!-- 步骤1 -->
        <div v-if="currentStep === 1">
          <div class="div_3 fz18 font_w_bold bc_F2F2F2">
            <img
              src="@/assets/images/title.png"
              style="
                width: 18px;
                margin-right: 6px;
                position: relative;
                top: 2px;
              "
              alt=""
            />主体信息
          </div>

          <el-form
            ref="subjectType"
            :model="publicForm.subject"
            size="mini"
            label-width="190px"
            class="form_1"
            :rules="rules"
          >
            <el-form-item prop="type" label="主体类型">
              <img
                @click="selectType('2')"
                v-if="isEnterprises"
                src="@/assets/images/qy-yes.png"
                class="typeOne"
                style=""
                alt=""
              />
              <img
                @click="selectType('2')"
                v-else
                src="@/assets/images/qy-no.png"
                class="typeOne"
                alt=""
              />
              <img
                @click="selectType('0')"
                v-if="isPersonal"
                src="@/assets/images/gr-yes.png"
                class="typeTwo"
                style=""
                alt=""
              />
              <img
                @click="selectType('0')"
                v-else
                src="@/assets/images/gr-no.png"
                class="typeTwo"
                alt=""
              />
              <img
                @click="selectType('6')"
                v-if="isOther"
                src="@/assets/images/qt-yes.png"
                class="typeTwo"
                alt=""
              />
              <img
                @click="selectType('6')"
                v-else
                src="@/assets/images/qt-no.png"
                class="typeTwo"
                alt=""
              />
              <!-- <el-select
                v-model="publicForm.subject.type"
                placeholder="请选择身份角色"
                @change="$refs.publicForm.clearValidate()"
              > -->

              <!-- <el-option v-if="!isSmallmicro" key="0" label="个人" value="0" />
                <el-option key="2" label="企业" value="2" /> -->
              <!-- <el-option v-if="!isSmallmicro" key="3" label="合作社" value="3" />
                <el-option v-if="!isSmallmicro" key="5" label="家庭农场" value="5" /> -->
              <!-- <el-option v-if="!isSmallmicro" key="6" label="其他" value="6" /> -->

              <!-- </el-select> -->
            </el-form-item>
          </el-form>

          <div class="div_3 fz18 font_w_bold bc_F2F2F2">
            <img
              src="@/assets/images/title.png"
              style="
                width: 18px;
                margin-right: 6px;
                position: relative;
                top: 2px;
              "
              alt=""
            />基础信息
          </div>

          <el-form
            ref="publicForm"
            :model="publicForm.subject"
            size="mini"
            label-width="150px"
            class="form_2"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              prop="name"
              :label="isPersonal ? '姓 名' : '企业名称'"
              :rules="[
                {
                  required: true,
                  message: isPersonal ? '请输入姓名' : '请输入企业名称',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="publicForm.subject.name"
                :placeholder="isPersonal ? '请输入姓名' : '请输入企业名称'"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>

            <el-form-item
              v-if="!isPersonal"
              prop="companyCode"
              label="社会信用代码"
              style="margin-bottom: 15px"
            >
              <el-input
                v-model="publicForm.subject.companyCode"
                placeholder="请输入统一社会信用代码或组织机构代码"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>

            <el-form-item
              v-if="!isPersonal"
              prop="legalPerson"
              label="法定代表人"
              style="margin-bottom: 15px"
            >
              <el-input
                v-model="publicForm.subject.legalPerson"
                placeholder="请输入法定代表人姓名"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>

            <el-form-item prop="idCard" label="身份证号">
              <el-input
                v-model="publicForm.subject.idCard"
                placeholder="请输入法人身份证号"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>

            <el-form-item
              v-if="!isPersonal"
              prop="contact"
              label="联 系 人"
              style="margin-bottom: 15px"
            >
              <el-input
                v-model="publicForm.subject.contact"
                placeholder="联系人真实姓名"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>

            <el-form-item
              prop="address"
              label="联系地址"
              style="margin-bottom: 15px"
            >
              <el-input
                v-model="publicForm.subject.address"
                placeholder="请输入联系人地址"
                :maxlength="input_l_300"
                show-word-limit
                class="word_limit_300"
              />
            </el-form-item>

            <el-form-item prop="accountName" label="账户名称">
              <el-input
                v-model="publicForm.subject.accountName"
                :placeholder="isPersonal ? '请输入账户名称' : '请输入企业/单位'"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>
            <el-form-item prop="openBank" label="开户银行">
              <el-input
                v-model="publicForm.subject.openBank"
                :placeholder="isPersonal ? '请输入开户银行' : '请输入企业/单位'"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>
            <el-form-item prop="bankCard" label="银行账号">
              <el-input
                v-model="publicForm.subject.bankCard"
                placeholder="请输入银行账号"
                :maxlength="input_l_50"
                show-word-limit
                class="word_limit_50"
              />
            </el-form-item>

            <el-form-item prop="contactWay" label="手机号码">
              <el-input
                v-model="publicForm.subject.contactWay"
                placeholder="请输入联系人手机号码"
                disabled
              />
            </el-form-item>
          </el-form>
        </div>

        <!-- 步骤2 -->
        <div v-if="currentStep === 1">
          <div class="div_3 fz18 font_w_bold bc_F2F2F2">
            <img
              src="@/assets/images/title.png"
              style="
                width: 18px;
                margin-right: 6px;
                position: relative;
                top: 2px;
              "
              alt=""
            />附件信息
          </div>

          <el-form
            label-position="top"
            ref="stepForm_2_1"
            :model="publicForm.subject"
            size="mini"
            class="form_3"
            :rules="rules"
            label-width="190px"
          >
            <!-- 身份证 -->
            <el-form-item prop="identityStr" style="padding: 0px 45px 45px 0px"
              :rules="{
                required: isRequireIdentity,
                message: '请上传身份证正反面',
                trigger: 'blur',
              }">
              <template slot="label" style="">
                <span>身份证件</span>
              </template>
              <div class="title">
                <div class="tip"></div>
                <div class="tip1">
                  上传法人/委托人身份证，单个文件大小不超过4M
                </div>
              </div>
              <MyUpload
                :http-request="
                  (uploadRes) =>
                    customLocalUpload({
                      type: 'apply',
                      file: uploadRes.file,
                      dataList: publicForm.subject.identityUrls,
                    })
                "
                file-type="any"
                name="identityStr"
                :file-list="publicForm.subject.identityUrls"
                @onRemove="
                  (file) =>
                    onRemoveFile({
                      target: publicForm.subject,
                      file,
                      key: 'identityUrls',
                    })
                "
                @onPicError="retryInternal"
                @onDownload="(file) => downLocalFile(file)"
                :file-max="1024 * 4000"
              />
            </el-form-item>

            <!-- 营业执照 -->
            <el-form-item
              prop="credentialStr"
              class="form-item"
              style="padding: 0px 45px 45px 0px"
              v-if="!isPersonal"
              :rules="{
                required: isRequireCredential,
                message: '请上传营业执照',
                trigger: 'blur',
              }"
            >
              <template slot="label" style="">
                <span>营业执照</span>
              </template>
              <div class="title">
                <div class="tip"></div>
                <div class="tip1">
                  上传营业执照原件/复印件，单个文件大小不超过4M
                </div>
              </div>
              <MyUpload
                :http-request="
                  (uploadRes) =>
                    customLocalUpload({
                      type: 'apply',
                      file: uploadRes.file,
                      dataList: publicForm.subject.credentialUrls,
                    })
                "
                file-type="any"
                name="credentialStr"
                :file-list="publicForm.subject.credentialUrls"
                @onRemove="
                  (file) =>
                    onRemoveFile({
                      target: publicForm.subject,
                      file,
                      key: 'credentialUrls',
                    })
                "
                @onPicError="retryInternal"
                @onDownload="(file) => downLocalFile(file)"
                :file-max="1024 * 4000"
              />
            </el-form-item>

            <!-- 授权附件 -->
            <el-form-item class="form-item" style="padding: 0px 45px 45px 0px">
              <template slot="label">
                <span>&nbsp;&nbsp;授权文件</span>
              </template>
              <div class="title">
                <div class="tip"></div>
                <div class="tip1">
                  上传授权委托文件（如有），单个文件大小不超过4M
                </div>
              </div>
              <MyUpload
                :http-request="
                  (uploadRes) =>
                    customLocalUpload({
                      type: 'apply',
                      file: uploadRes.file,
                      dataList: publicForm.subject.authFileUrls,
                    })
                "
                file-type="any"
                name="authFileStr"
                :file-list="publicForm.subject.authFileUrls"
                @onRemove="
                  (file) =>
                    onRemoveFile({
                      target: publicForm.subject,
                      file,
                      key: 'authFileUrls',
                    })
                "
                @onPicError="retryInternal"
                @onDownload="(file) => downLocalFile(file)"
                :file-max="1024 * 4000"
              />
            </el-form-item>

            <!-- 相关附件 -->
            <el-form-item class="form-item" style="padding: 0px 45px 45px 0px">
              <template slot="label">
                <span>&nbsp;&nbsp;相关附件</span>
              </template>
              <div class="title">
                <div class="tip"></div>
                <div class="tip1">
                  上传附件文件（如有），单个文件大小不超过4M
                </div>
              </div>
              <MyUpload
                :http-request="
                  (uploadRes) =>
                    customLocalUpload({
                      type: 'apply',
                      file: uploadRes.file,
                      dataList: publicForm.subject.relatedUrls,
                    })
                "
                file-type="any"
                name="relatedStr"
                :file-list="publicForm.subject.relatedUrls"
                @onRemove="
                  (file) =>
                    onRemoveFile({
                      target: publicForm.subject,
                      file,
                      key: 'relatedUrls',
                    })
                "
                @onPicError="retryInternal"
                @onDownload="(file) => downLocalFile(file)"
                :file-max="1024 * 4000"
              />
            </el-form-item>
          </el-form>
          <el-form
            label-position="top"
            ref="stepForm_3_1"
            :model="publicForm"
            size="mini"
            class="form_3"
            :rules="rules"
            label-width="190px"
          >
            <!-- 付款凭证 -->
            <el-form-item
              style="padding: 0px 45px 0px 0px"
              class="form-item02"
              prop="remitStr"
              label="付款凭证"
              :rules="{
                required: isRequireRemit,
                message: '请上传付款证明原件',
                trigger: 'blur',
              }"
            >
              <div class="title">
                <div class="tip"></div>
                <div class="tip1">
                  上传交易保证金付款凭证，单个文件大小不超过4M
                </div>
              </div>
              <MyUpload
                :http-request="
                  (uploadRes) =>
                    customLocalUpload({
                      type: 'apply',
                      file: uploadRes.file,
                      dataList: publicForm.remitUrls,
                    })
                "
                file-type="image"
                name="remitStr"
                :file-list="publicForm.remitUrls"
                @onRemove="
                  (file) =>
                    onRemoveFile({
                      target: publicForm,
                      file,
                      key: 'remitUrls',
                    })
                "
                @onPicError="retryInternal"
                @onDownload="(file) => downLocalFile(file)"
                :file-max="1024 * 4000"
              />
            </el-form-item>
          </el-form>
          <!-- 提交 -->
          <div
            v-loading="signuping"
            class="
              div_2
              bc_0983CC
              c_fff
              fz16
              text_center
              cursor_pointer
              margin_auto
            "
            @click="onNextClick('publicForm')"
          >
            提交报名
          </div>
        </div>

        <!-- 步骤3 -->
        <div
          v-if="currentStep === 3"
          class="div_4 d_flex align_item_c flex_direction_col"
        >
          <img src="@/assets/images/s_success_icon.png" alt="" />
          <div class="fz20 c_1A1A1A div_5 text_center">提交成功</div>
          <span class="fz14 c_808080">{{ countDown }}秒后自动跳转</span>
        </div>
      </div>
    </div>

    <!-- 预览图片 -->
    <PreviewImg @closePreviewImg="closePreviewImg" />

    <ImportJs
      :src="static_resource + '/js/oss.js'"
      script-key="oss"
      @loadComplete="ossCompleteFn"
    />

    <AgreementRead
      v-model="agreementReadModal"
      :content="applyAgreementData.applyProtocol.content"
      :title="applyAgreementData.applyProtocol.title"
      @onCancal="onCancalAgreement"
      @onConfirm="onConfirmAgreement"
    />
  </div>
</template>

<script>
import MyUpload from "@/components/my-upload/index.vue";
import UploadTip from "@/components/base/UploadTip.vue";
import PreviewImg from "@/components/base/PreviewImg.vue";
import SiteBreadcrumb from "@/components/base/SiteBreadcrumb.vue";
import { user_gee_web_init } from "@/api/public";
import { auction_apply } from "@/api/action";

import bus from "@/utils/bus";
import { isvalidPhone } from "@/utils";
import { isValidIdcard } from "@/utils/validFiled";

import { mapMutations, mapGetters, mapActions } from "vuex";
import {
  _input_l_50,
  _input_l_100,
  _input_l_150,
  _input_l_300,
  _input_l_500,
} from "@/utils/setting";

import ImportJs from "@/components/base/ImportJs.vue";
import { TradeMode } from "@/enums";
import {
  portal_project_apply,
  cms_code_article_info,
  portal_project_apply_init,
} from "@/api/portal";
import AgreementRead from "@/components/template/AgreementRead.vue";

export default {
  components: {
    UploadTip,
    PreviewImg,
    ImportJs,
    SiteBreadcrumb,
    AgreementRead,
    MyUpload,
  },

  data() {
    const validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };

    const validIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入法人代表身份证号码"));
      } else if (!isValidIdcard(value)) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        // 身份选择
        type: [{ required: true, message: "请选择身份角色", trigger: "blur" }],

        // 企业信息
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],

        companyCode: [
          {
            required: true,
            message: "请输入公司社会信用代码",
            trigger: "blur",
          },
        ],
        legalPerson: [
          {
            required: true,
            message: "请输入法人代表姓名",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            trigger: "blur",
            validator: validIdCard,
          },
        ],
        contactWay: [
          { required: true, trigger: "blur", validator: validPhone },
        ],

        // 银行卡信息
        openBank: [
          { required: true, message: "请输入开户行名称", trigger: "blur" },
        ],
        bankCard: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        accountName: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
        ],

        // // 身份证件
        // identityStr: [
        //   { required: true, message: "请上传身份证正反面", trigger: "blur" },
        // ],

        relatedStr: [
          { required: true, message: "请上传相关附件", trigger: "blur" },
        ],
        authFileStr: [
          { required: true, message: "请上传授权文件", trigger: "blur" },
        ],
        // credentialStr: [
        //   { required: true, message: "请上传营业执照", trigger: "blur" },
        // ],
        agented: [
          { required: true, message: "请选择是否有代理人", trigger: "blur" },
        ],
        agent: [
          { required: true, message: "请输入代理人姓名", trigger: "blur" },
        ],
        agentWay: [
          { required: true, message: "请输入代理人手机号", trigger: "blur" },
        ],
        agentIdentityStr: [
          { required: true, message: "请上传代理人身份证", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入联系人地址", trigger: "blur" },
        ],
      },
      rules02: {
        // 身份证件
        // identityStr: [
        //   { required: true, message: "请上传身份证正反面", trigger: "blur" },
        // ],

        // credentialStr: [
        //   { required: true, message: "请上传营业执照", trigger: "blur" },
        // ],
        relatedStr: [
          { required: true, message: "请上传相关附件", trigger: "blur" },
        ],
        authFileStr: [
          { required: true, message: "请上传授权文件", trigger: "blur" },
        ],
      },
      currentStep: 1,

      publicForm: {
        subject: {
          type: "0", // 0个人
          identityUrls: [], // 身份证
          relatedUrls: [], // 相关附件
          authFileUrls: [], //授权文件
          credentialUrls: [], //营业执照
          identityStr: "",
          relatedStr: "",
          authFileStr: "",
          credentialStr: "",
        },
        remitUrls: [], // 打款凭证
        remitStr: "",
      },

      countDown: 60, // 1分钟
      countDownTimer: null,
      signuping: false,
      agreementReadModal: true,
      applyAgreementData: {},
    };
  },
  computed: {
    ...mapGetters([
      "Bucket_pub",
      "Bucket_internal",
      "isOssComplete",
      "static_resource",
    ]),
    input_l_50() {
      return _input_l_50;
    },
    input_l_100() {
      return _input_l_100;
    },
    input_l_150() {
      return _input_l_150;
    },
    input_l_300() {
      return _input_l_300;
    },
    input_l_500() {
      return _input_l_500;
    },

    isPersonal() {
      return this.publicForm.subject.type === "0";
    },
    isEnterprises() {
      return this.publicForm.subject.type === "2";
    },
    isOther() {
      return this.publicForm.subject.type === "6";
    },
    tradeMode() {
      return this.$route.query?.tradeMode - 0;
    },
    applyUrl() {
      switch (this.tradeMode) {
        case TradeMode.AUCTION:
          return auction_apply;
        case TradeMode.DEAL:
        case TradeMode.SMALL_SIMPLE:
          return portal_project_apply;
      }
    },
    isSmallmicro() {
      return ["smallmicro"].includes(this.publicForm.tradeKind);
    },
    isRequireIdentity() {
      return Boolean(this.$route.query?.margin - 0);
    },
    isRequireCredential() {
      return Boolean(this.$route.query?.margin - 0);
    },
    isRequireRemit() {
      return Boolean(this.$route.query?.margin - 0);
    },
  },
  watch: {
    currentStep: function (n, o) {
      this.countDownTimer && clearInterval(this.countDownTimer);
      this.countDown = 60;
      if (n <= 0) {
        this.currentStep = 1;
      }
      if (n > 3) {
        this.currentStep = 3;
      }

      if (n === 3) {
        this.countDown = 3;
        this.countDownTimer = setInterval(() => {
          this.countDown--;
          if (this.countDown <= 0) {
            this.countDown = 0;
            clearInterval(this.countDownTimer);
          }
        }, 1000);
      }
    },
    countDown(n) {
      if (n === 0) {
        this.$router.go(-1);
      }
    },
    "publicForm.subject.type": function (n) {
      if (n === "0") {
        this.$set(this.publicForm.subject, "name", "");
        this.$set(this.publicForm.subject, "companyCode", "");
      }
    },

    isSmallmicro(n) {
      if (n) {
        this.$set(this.publicForm.subject, "type", "2");
      } else {
        this.$set(this.publicForm.subject, "type", "0");
      }
    },
  },
  created() {
    const { projectNo, tradeKind, title, transferMode } = this.$route.query;
    this.publicForm.tradeKind = tradeKind;
    this.publicForm.projectNo = projectNo || "";
    this.publicForm.title = title;
    this.publicForm.transferMode = transferMode;
    this.$set(this.publicForm.subject, "agented", 0);
    this.$set(this.publicForm, "subject02", {});
    this.$set(
      this.publicForm.subject,
      "contactWay",
      JSON.parse(localStorage.getItem("userinfo"))?.phone || ""
    );
    console.log("publicForm:", this.publicForm);
    this.gerPortalProjectApplyInit();
    this.publicForm.subject.type = "2";
  },

  methods: {
    ...mapMutations({
      openPreviewImg: "upload/openPreviewImg",
      closePreviewImg: "upload/closePreviewImg",
      onRemoveFile: "upload/onRemoveFile",
      onExceedUpload: "upload/onExceedUpload",
      ossCompleteFn: "app/ossCompleteFn",
      signatureUrls: "upload/signatureUrls",
      retryInternal: "upload/retryInternal",
      downLocalFile: "upload/downLocalFile02",
    }),
    ...mapActions({
      customOssUploadRequest: "upload/customOssUploadRequest",
      customLocalUpload: "upload/customLocalUpload",
    }),
    // 文件上传之前
    busBeforeUpload(file, who) {
      const res = bus.$emit("beforeUpload", file, this.$refs[who]);
      return res.uploadPass;
    },
    // 下一步 click
    onNextClick(formName) {
      let count = 0;
      this.setUploadFileValue();
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          count++;
        }
      });
      if (this.signuping) return;
      this.setUploadFileValue();
      this.$refs?.stepForm_2_1?.validate((valid) => {
        if (valid) {
          count++;
        }
      });
      this.$refs?.stepForm_3_1?.validate((valid) => {
        if (valid) {
          count++;
        }
      });
      if (count == 3) {
        this.auctionApply();
        this.currentStep = 3;
      }
    },

    async gerPortalProjectApplyInit() {
      let { data } = await portal_project_apply_init({
        projectNo: this.$route.query?.projectNo,
      });
      this.applyAgreementData = data;
    },
    // // 提交报名 click
    // async onSumitSignup(formName) {

    //   let stepForm_2_1 = false
    //   // 步骤2有两个表单
    //   this.$refs?.stepForm_2_1?.validate((valid) => {
    //     stepForm_2_1 = valid
    //   })
    //   if (stepForm_2_1) {
    //     this.$refs?.stepForm_3_1?.validate((valid) => {

    //     })
    //   }
    // },
    // 报名 api
    async auctionApply() {
      this.signuping = true;
      try {
        const res = await this.applyUrl(this.publicForm);
        if (res.code === 200) {
          this.signuping = false;
          this.currentStep++;

          this.$notify({
            type: "success",
            message: "报名成功",
          });
        }
      } catch (err) {
        this.signuping = false;
      }
    },
    async selectType(v) {
      this.publicForm.subject.type = v;
    },
    // 设置上传文件的值
    setUploadFileValue() {
      this.$set(
        this.publicForm,
        "remitStr",
        this.publicForm.remitUrls.length
          ? this.publicForm.remitUrls
              .map((obj) => obj.url) // 提取每个对象的 url 属性
              .join(",")
          : null
      );
      this.$set(
        this.publicForm.subject,
        "identityStr",
        this.publicForm.subject.identityUrls[0]?.url
          ? JSON.stringify(this.publicForm.subject.identityUrls)
          : null
      );
      this.$set(
        this.publicForm.subject,
        "credentialStr",
        this.publicForm.subject.credentialUrls[0]?.url
          ? JSON.stringify(this.publicForm.subject.credentialUrls)
          : null
      );
      this.$set(
        this.publicForm.subject,
        "relatedStr",
        this.publicForm.subject.relatedUrls[0]?.url
          ? JSON.stringify(this.publicForm.subject.relatedUrls)
          : null
      );
      this.$set(
        this.publicForm.subject,
        "authFileStr",
        this.publicForm.subject.authFileUrls[0]?.url
          ? JSON.stringify(this.publicForm.subject.authFileUrls)
          : null
      );

    },
    // // 获取报名协议
    // async getApplyAgreement(){
    //   let {data} = await cms_code_article_info({
    //     code: 'apply_agreement'
    //   })
    //   this.applyAgreementData = data
    // },
    // 取消报名协议
    onCancalAgreement() {
      this.$router.go(-1);
    },
    // 同意报名协议
    onConfirmAgreement() {
      this.agreementReadModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  position: relative;
  top: -20px;
}
.form-item02 {
  position: relative;
  top: -50px;
}
.upl {
  position: relative;
  top: -30px;
}
.upl2 {
  position: relative;
  top: -30px;
}
.upl3 {
  position: relative;
  top: -30px;
}
.title {
  display: flex;
  position: relative;
  top: -38px;
  right: -85px;
}
.tip {
  width: 2px;
  height: 18px;
  background-color: rgb(194, 201, 194);
  position: relative;
  top: 5px;
}
.tip1 {
  font-size: 13px;
  margin-left: 10px;
  position: relative;
  top: -1px;
  color: #909399;
}
.typeOne {
  width: 230px;
  margin-right: 6px;
  position: relative;
  top: -20px;
  margin-left: 15px;
}
.typeTwo {
  width: 230px;
  margin-right: 6px;
  position: relative;
  top: -20px;
  margin-left: 68px;
}
.apply_w {
  margin: 0 auto 10px auto;
  padding-top: 16px;
  .content_w {
    padding: 40px;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
  }
  .step_c_w {
    text-align: center;
    margin: 0 auto 35px auto;
    font-size: 30px;
  }
  .div_1 {
    padding: 7px 14px;
    border-left: 4px solid #0983cc;
  }
  .div_6 {
    padding: 7px 14px;
    border-left: 4px solid #0983cc;
  }
  .div_3 {
    padding: 12px 14px;
    background: rgba($color: #3084cf, $alpha: 0.1);
  }
  .div_2 {
    width: 400px;
    height: 52px;
    line-height: 52px;
    &:active {
      background-color: rgba($color: #0983cc, $alpha: 0.9);
    }
  }
  .div_4 {
    margin: 200px 0;
  }
  .div_5 {
    margin: 20px auto;
  }

  .form_1 {
    margin: 52px 0px 0px 0px;
    height: 120px;
    position: relative;
    left: -70px;
  }
  .form_2 {
    margin: 30px 0;
    margin-left: 48px;
    display: flex;
    flex-wrap: wrap; /* 允许子元素在必要时换行 */
  }
  .form_3 {
    margin: 30px 0;
    margin-left: 48px;
  }
  .button_2 {
    width: 179px;
    height: 52px;
    border-color: #e6e6e6;
    &:focus,
    &:hover {
      color: #1a1a1a;
      background-color: rgba($color: #e6e6e6, $alpha: 0.5);
    }
  }
  .send_vcode_btn {
    float: left;
    width: 168px;
    padding: 16px 0;
    margin: 0 0 0 10px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    background: #0983cc;
    cursor: pointer;
  }
  .send_vcode_btn.is_active {
    &:active {
      background-color: rgba($color: #0983cc, $alpha: 0.9);
    }
  }
  .actions_upload {
    position: relative;
    width: 244px;
    height: 156px;
    padding: 22px 52px;
    box-sizing: border-box;
    margin: 0 10px 10px 0;
    &:last-child {
      margin: 0;
    }
    & > img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      .options {
        display: flex;
        & > span {
          display: flex;
        }
      }
    }
    & > .options {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#000, 0.5);
      & > span {
        display: none;
        width: 50px;
        height: 50px;
        color: #fff;
        font-size: 25px;
        cursor: pointer;
      }
    }
  }

  //上传
  ::v-deep .el-upload-list {
    display: none;
  }

  ::v-deep .el-input,
  ::v-deep .el-input__inner {
    width: 300px;
    height: 40px;
    margin-right: 56px;
  }
  ::v-deep .el-form-item__label {
    line-height: 30px;
    font-size: 16px;
  }

  // 步骤条
  ::v-deep .el-step__main {
    .is-finish {
      color: #6db6fc;
    }
  }
  ::v-deep .is-finish .el-step__icon {
    background: #2caeff;
  }
  ::v-deep .el-step {
    &:first-child {
      .el-step__head,
      .el-step__main {
        text-align: left;
      }
    }
  }
  ::v-deep .el-step {
    &:last-child {
      .el-step__head,
      .el-step__main {
        text-align: right;
      }
    }
  }
  ::v-deep .el-step .el-step__line {
    height: 1px;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #e6e6e6;
  }
  ::v-deep .el-step__icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 1px solid #e6e6e6;
    font-size: 30px;
  }
  ::v-deep .el-step__title {
    font-size: 14px;
  }
  ::v-deep .is-finish > .el-step__icon {
    color: #fff;
    background-color: #6db6fc;
  }
  ::v-deep .is-process,
  .is-wait {
    color: #999;
  }
}
.risk_tip_w {
  align-items: center;
  padding: 13px 0;
  margin: 10px 0;
  background-color: rgba($color: #ef9a35, $alpha: 0.1);
  .tip_title {
    width: 150px;
    padding: 5px 25px;
  }
  p {
    &:first-child {
      margin: 0 0 16px 0;
    }
  }
  .desc_w {
    display: flex;
    margin: 7px 40px 7px 50px;
  }
}
</style>
